import { render } from "./OpenScreen.vue?vue&type=template&id=46b8b01a&scoped=true"
import script from "./OpenScreen.vue?vue&type=script&lang=js"
export * from "./OpenScreen.vue?vue&type=script&lang=js"

import "./OpenScreen.vue?vue&type=style&index=0&id=46b8b01a&lang=scss&scoped=true"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b8b01a"]])

export default __exports__